import React from 'react';

type AfterIdleProps = {
  children: React.ReactNode;
  timeoutMs?: number;
};

export default function AfterIdle({ children, timeoutMs = 1200 }: AfterIdleProps) {
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    const onReady = () => {
      if (!cancelled) setReady(true);
    };

    if (typeof window !== 'undefined') {
      const w = window as typeof window & {
        requestIdleCallback?: (cb: () => void, options?: { timeout: number }) => number;
      };
      if (w.requestIdleCallback) {
        w.requestIdleCallback(onReady, { timeout: timeoutMs });
      } else {
        setTimeout(onReady, timeoutMs);
      }
    } else {
      setTimeout(onReady, timeoutMs);
    }

    return () => {
      cancelled = true;
    };
  }, [timeoutMs]);

  if (!ready) return null;
  return <>{children}</>;
}
